window.OAAlgoliaApi = {
  _client: null,

  /**
   * @param {string} appId
   * @param {string} apiKey
   * @returns {object}
   */
  getClient: function (appId, apiKey) {
    if (!this._client) {
      this._client = window["algoliasearch/lite"].liteClient(appId, apiKey);
    }
    return this._client;
  },

  filters: {
    /**
     * @param {string} facet
     * @param {string} value
     * @returns {string}
     */
    facetFilter: function (facet, value) {
      return `${facet}:${value}`;
    },

    /**
     * @param {string} facet
     * @param {boolean|string} value
     * @returns {string}
     */
    booleanFilter: function (facet, value) {
      return `${facet}:${value}`;
    },

    /**
     * @param {string} facet
     * @param {'<' | '<=' | '=' | '!=' | '>=' | '>'} operator
     * @param {number|string} value
     * @returns {string}
     */
    numericComparison: function (facet, operator, value) {
      return `${facet} ${operator} ${value}`;
    },

    /**
     * @param {string} facet
     * @param {number|string} low
     * @param {number|string} high
     * @returns {string}
     */
    numericRange: function (facet, low, high) {
      return `${facet}:${low} TO ${high}`;
    },

    /**
     * @param {string} value
     * @returns {string}
     */
    tagFilter: function (value) {
      return value;
    },

    /**
     * @param {string} value
     * @returns {string}
     */
    quote: function (value) {
      const needsQuotes = value.includes(' ')
        || value.includes('"')
        || value.includes('\'')
        || 'AND' === value
        || 'OR' === value
        || 'NOT' === value;
      if (!needsQuotes) {
        return value;
      }
      // TODO: JSON.stringify('UnifiedMove™ High Waisted Shorts 6"') produces "UnifiedMove™ High Waisted Shorts 6\"" — it escapes the double quote with a backslash. Algolia's docs don't mention backslash escaping in filter values. The previous approach (pick the other quote type) was safer. Worth testing whether Algolia accepts \" in filters.
      return JSON.stringify(value);
    },

    AND: ' AND ',

    /**
     * @param {Array} filters
     * @returns {string}
     */
    and: function (filters) {
      return `${filters.join(' AND ')}`;
    },

    /**
     * @param {Array} filters
     * @returns {string}
     */
    or: function (filters) {
      return `${filters.join(' OR ')}`;
    },

    /**
     * @param {string} expression
     * @returns {string}
     */
    not: function (expression) {
      return `NOT ${expression}`;
    },

    /**
     * @param {string} expression
     * @returns {boolean}
     */
    startsWithNot: function (expression) {
      return expression.trimStart().startsWith('NOT ');
    },

    /**
     * @param {string} expressions
     * @returns {string}
     */
    group: function (expressions) {
      return `(${expressions})`;
    },
  },
};